import { Component, OnInit, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { G_BrandsViewModel } from 'src/app/viewmodels/g-settings/G_BrandsViewModel';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JqHelper } from 'src/app/common/jq-helper';
import Swal from 'sweetalert2';
import { SaveGBrandRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';

@Component({
  selector: 'app-brand-form',
  templateUrl: './brand-form.component.html',
  styleUrls: ['./brand-form.component.scss']
})
export class BrandFormComponent implements OnInit {

  @Input() public vm: SaveGBrandRequest;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>();
  private submitted = false;
  public IsDublicate: boolean = false;
  modalRef: BsModalRef;
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
  ) { }

  ngOnInit() {
    if (this.vm == undefined) {
      this.vm = new SaveGBrandRequest();
    }
    if (this.modal_title == undefined) {
      this.modal_title = "Brand";
    }
  }

  saveOrUpdate() {
    this._jq.showSpinner(true);
    this._uow.gSettingService
      .SaveGBrandAsync(this.vm)
      .toPromise().then((res: any) => {
        console.log(res);
        this.submitted = true;
        this.bsmRef.hide();
        this.onSubmitted.emit(this.submitted);
        Swal.fire(
          'Created!',
          'Created/Updated! Successfully',
          'success'
        )
      })
      .catch((error) => {
        Swal.fire(
          'Failure!',
          error.error.message,
          'error'
        )
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(this.submitted);
      });
  }

  checkBrandDublication(tagName){
    debugger
    this._jq.showSpinner(true);
    this._uow.brandService.checkDublication(tagName).toPromise().then((res : any)=>{
      if (res === true) {
        this.IsDublicate = false;
      }else{
        this.IsDublicate = true;
      }
      this._jq.showSpinner(false);
    }).catch((error) => {
      console.log(`Promise rejected with ${JSON.stringify(error)}`);
      this.onSubmitted.emit(this.submitted);
      this._jq.showSpinner(false);
    });
  }

  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._modalService.show(template);
    }
  }

  openTagTypeModel(template: TemplateRef<any>) {
    this.openModal(template);
  }

  onBrandSubmitted(e) {
    if (e == true) {
      this.modalRef.hide();
      this.ngOnInit();
    }
  }

   closeModal() {
    this.bsmRef.hide();
    this.onSubmitted.emit(true); // Emit event to refresh list
  }
}
